import { FAQ } from "../models/FAQ.tsx";
import { cachedFetch, invalidateKey } from "./queryCache.tsx";
import { getLiteQueryDocs } from "./firestoreLiteQuery.ts";

export const FAQ_CACHE_KEY = "faq:questions";
const FAQ_CACHE_TTL_MS = 5 * 60_000;

/** Lista FAQ completa (sin orderBy: docs legacy sin `order` no se excluyen). */
export async function fetchFAQQuestions(): Promise<FAQ[]> {
  return cachedFetch(FAQ_CACHE_KEY, async () => {
    const docs = await getLiteQueryDocs("questions");
    return docs.map(docSnap => docSnap.data() as FAQ);
  }, { ttlMs: FAQ_CACHE_TTL_MS, staleMs: 30 * 60_000 });
}

export function invalidateFAQCache(): void {
  invalidateKey(FAQ_CACHE_KEY);
}
